import { forwardRef } from 'react'
import PropTypes from 'prop-types'

import TransactionHistoryItem from 'components/TransactionHistoryItem'

const PaymentTransactionHistory = forwardRef(({ order, id }, ref) => {
  return (
    <section className="order-details__section" id={id} ref={ref}>
      <header className="order-details__header -vertical -smaller-margin">
        <h4 className="order-details__main-header">Payment Transactions</h4>
      </header>
      {order?.paymentTransactions?.map((transactionHistory, idx) => (
        <TransactionHistoryItem
          transactionHistory={transactionHistory}
          key={idx}
        />
      ))}
    </section>
  )
})

PaymentTransactionHistory.displayName = 'PaymentTransactionHistory'

PaymentTransactionHistory.propTypes = {
  order: PropTypes.object,
  id: PropTypes.string,
}

export default PaymentTransactionHistory
